import { ChangeDetectionStrategy, Component, inject, input, model, signal } from '@angular/core';
import { ControlValueAccessor, NgControl, ReactiveFormsModule } from '@angular/forms';
import { v4 as uuidv4 } from 'uuid';
import { CheckboxComponent } from '../../../interactive-labels/checkbox/checkbox.component';
import { FormErrorComponent } from '../../form-error/form-error.component';
import { InputSize } from '../../../enum/input-size.enum';

@Component({
  selector: 'lib-checkbox-form-field',
  imports: [ReactiveFormsModule, CheckboxComponent, FormErrorComponent],
  templateUrl: './checkbox-form-field.component.html',
  styleUrl: './checkbox-form-field.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CheckboxFormFieldComponent implements ControlValueAccessor {
  readonly ngControl = inject(NgControl, { self: true });

  label = input.required<string>();
  indeterminate = model<boolean>(false);
  isSubmitted = input<boolean>(false);
  size = input<InputSize>(InputSize.large);

  disabled = signal<boolean>(false);
  selected = signal<boolean>(false);
  inputId: string = uuidv4();

  constructor() {
    if (this.ngControl) {
      this.ngControl.valueAccessor = this;
    }
  }

  checkboxClick() {
    this.selected.update(value => !value || this.indeterminate());
    this.onChange(this.selected());
    this.indeterminate.set(false);
  }

  writeValue(value: boolean): void {
    this.selected.set(value);
  }
  registerOnChange(fn: (value: boolean) => void): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    this.disabled.set(isDisabled);
  }
  private onChange: (value: boolean) => void = () => {
    // default onChange
  };
  private onTouched: () => void = () => {
    // default onTouched
  };
}
